import numeral from 'numeral';

// ----------------------------------------------------------------------

export function fCurrency(number, currency = 'ريال', digits = 2) {
  const digitsFormat = digits === 4 ? '0,0.00[00]' : '0,0.00';
  return `${numeral(number).format(Number.isInteger(number) ? '0,0' : digitsFormat)} ${currency}`;
}

export function fQty(number) {
  return numeral(number).format('0,0.[0000]');
}

export function fPercent(number) {
  return numeral(number / 100).format('0.0%');
}

export function fNumber(number) {
  return numeral(number).format();
}

export function fShortenNumber(number) {
  return numeral(number).format('0.00a').replace('.00', '');
}

export function jShortenNumber(number) {
  return numeral(number).format('0.00').replace('.00', '');
}

export function fData(number) {
  return numeral(number).format('0.0 b');
}
